import axios from 'axios';
import { trimStringForQuery } from 'utils/utils';

const API_URL = '/api/v1/registration-organization/';
const CREATE = 'create';
// eslint-disable-next-line

const updateOrganization = async ({
	organizationId,
	name,
	orList,
	active,
	deleteList,
	createdBy,
	modifiedBy,
}) => {

	return await axios.post(`${API_URL}${CREATE}`, {
		organizationId: organizationId,
		name: name,
		orList: orList,
		active: active,
		deleteList: deleteList,
		createdBy: createdBy,
		modifiedBy: modifiedBy,
	});
};

export {
	updateOrganization,
};
